import React from "react";
import { LastQueriesBlockProps } from "../../types/search";
import "../../styles.css";

/**
 * LastQueriesBlock - Displays a list of recent search queries
 *
 * This component shows a static list of last queries with a "Clear" button
 * that has no functionality (for default state only).
 */
const LastQueriesBlock: React.FC<LastQueriesBlockProps> = ({
  queries,
  onQueryClick,
  onClearClick,
  onQueryRemove,
}) => {
  const handleQueryClick = (query: string) => {
    // Optional callback for future use
    if (onQueryClick) {
      onQueryClick(query);
    }
  };

  const handleClearClick = () => {
    // Optional callback for future use
    if (onClearClick) {
      onClearClick();
    }
  };

  const handleQueryRemove = (query: string, event: React.MouseEvent) => {
    event.stopPropagation();
    if (onQueryRemove) {
      onQueryRemove(query);
    }
  };

  return (
    <div className="last-queries-block">
      <div className="block-header">
        <div className="block-title">Вы искали</div>
        <button
          type="button"
          className="clear-button"
          onClick={handleClearClick}
          aria-label="Clear search history"
        >
          Очистить
        </button>
      </div>

      {queries.length > 0 ? (
        <ul className="queries-list">
          {queries
            .filter((_, i) => i < 5)
            .map((item) => (
              <li
                key={item.id}
                className="query-item"
                style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
              >
                <button
                  type="button"
                  className="query-button"
                  onClick={() => handleQueryClick(item.query)}
                  aria-label={`Search for ${item.query}`}
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    textAlign: "left",
                    padding: "8px 0",
                  }}
                >
                  <img
                    className="fas fa-history query-icon"
                    src="/src/img/refresh-ccw-01.svg"
                    style={{ marginRight: "8px" }}
                  />
                  <span className="query-text">{item.query}</span>
                </button>
                {onQueryRemove && (
                  <button
                    type="button"
                    className="query-remove-button"
                    onClick={(e) => handleQueryRemove(item.query, e)}
                    aria-label={`Remove ${item.query} from history`}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      padding: "4px",
                      marginLeft: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src="/src/img/x.svg"
                      alt="Remove"
                      style={{ width: "16px", height: "16px", opacity: 0.6 }}
                    />
                  </button>
                )}
              </li>
            ))}
        </ul>
      ) : (
        <p className="empty-message">Нет последних запросов</p>
      )}
    </div>
  );
};

export default LastQueriesBlock;
